/** Workflows: ang checklist na "Tapusin ang setup" ng isang workflow (ano pa ang kulang bago ito tumakbo). Isinasama sa `engage.workflows.setup`. */
export const workflowsSetup = {
  title: "Tapusin ang setup",
  subtitle: "Natitirang susuriin: {{count}}. Sumusunod ang listahang ito sa na-save ninyong draft.",
  allDone: "Kumpleto na ang setup",
  status: { done: "Tapos na", todo: "Gawin", warn: "Suriin" },
  fix: {
    home: "Buksan ang Home sa Widget Studio",
    actions: "Buksan ang Actions",
    webhooks: "Buksan ang Webhooks",
    team: "Buksan ang Team",
    leads: "Buksan ang Leads",
    hours: "Itakda ang office hours",
    identity: "Buksan ang security ng widget",
    handoff: "Buksan ang mga setting ng handoff",
  },
  homeSteps: {
    publish: "I-publish ang workflow na ito gamit ang Publish button sa itaas.",
    option: "Sa Widget Studio, buksan ang Home, piliin ang Magdagdag ng opsyon, itakda ang action sa Magsimula ng workflow, at piliin ang “{{name}}”.",
    widget: "I-publish ang widget para makita ng mga bisita ang bagong opsyon.",
  },
  homeNote: {
    started: "Sinisimulan ng: Home option na “{{label}}” sa {{agent}}",
    linked: "Nakakabit sa Home option na “{{label}}” sa {{agent}}, pero hindi pa ito live",
    none: "Wala pa sa anumang Home option",
    open: "Buksan ang Home sa Widget Studio",
  },
  deliveryModes: { events: "lahat ng event na sinusubaybayan nito", filtered: "ang mga event na pasok sa mga filter nito", workflows: "mga mensahe ng workflow lang" },
  scope: { allAssistants: "lahat ng assistant", allChannels: "lahat ng channel" },
  items: {
    publish: {
      never_published: "I-publish ang workflow na ito. Draft pa lang ito, kaya hindi ito makikita o tatakbo para sa mga bisita at sa team ninyo.",
      paused: "Naka-pause ang workflow na ito kaya hindi ito tumatakbo. I-resume ito para magsimulang muli.",
      unpublished_changes: "May mga na-save kayong pagbabago na hindi pa napa-publish. I-publish para maging live ang mga ito.",
      done: "Napa-publish na. Kapareho ng draft ninyo ang live na bersyon.",
    },
    home_option: {
      no_home_option: "Walang Home option na nagsisimula ng workflow na ito, kaya hindi ito tatakbo. Para ikabit ito:",
      draft_only: "Nakaturo rito ang Home option na “{{label}}” sa {{agent}}, pero nasa draft pa lang ng widget. I-publish ang widget para makita ito ng mga bisita.",
      home_off: "Nakaturo rito ang Home option na “{{label}}” sa {{agent}}, pero naka-off ang Home sa naka-publish na widget. I-on ang Home, saka i-publish ang widget.",
      agent_excluded: "Nakaturo rito ang Home option na “{{label}}” sa {{agent}}, pero hindi nakatakda ang workflow na ito para sa {{agent}}. Idagdag ang assistant na iyon sa mga setting ng workflow sa ibaba, o ilipat ang option sa assistant na saklaw nito.",
      done: "Sinisimulan ng Home option na “{{label}}” sa {{agent}}.",
      done_more: "Sinisimulan ng Home option na “{{label}}” sa {{agent}} at ng {{count}} pa.",
    },
    booking_action: {
      missing: "May hakbang na nagpapakita ng booking card, pero wala na ang booking action nito. Pumili ng iba sa hakbang na iyon, o gumawa sa Actions.",
      disabled: "Naka-off ang booking action na “{{name}}” sa {{agent}}, kaya hindi maipapakita ang booking card. I-on ito sa Actions.",
      done: "Handa na ang booking action na “{{name}}” sa {{agent}}.",
    },
    lead_form: {
      missing: "May hakbang na nagpapakita ng lead form, pero wala na ang lead capture action nito. Pumili ng iba sa hakbang na iyon, o gumawa sa Actions.",
      disabled: "Naka-off ang lead capture action na “{{name}}” sa {{agent}}, kaya hindi maipapakita ang lead form. I-on ito sa Actions.",
      done: "Handa na ang lead capture action na “{{name}}” sa {{agent}}.",
    },
    endpoint: {
      missing: "May hakbang na Magpadala ng webhook o Data connector na nakaturo sa endpoint na wala na. Pumili ng iba sa hakbang na iyon, o magdagdag sa Webhooks.",
      disabled: "Naka-off ang webhook endpoint na “{{name}}”, kaya walang naipapadala rito. I-on ito sa Webhooks.",
      not_workflows_only: "Tumatanggap din ang webhook endpoint na “{{name}}” ng {{mode}}. Sa Webhooks, itakda ang delivery nito sa “Mula lang sa mga workflow ko” kung mga mensahe lang ng workflow na ito ang dapat nitong matanggap.",
      done: "Mensahe lang mula sa workflows ang tinatanggap ng webhook endpoint na “{{name}}”.",
    },
    team: {
      missing: "May hakbang na gumagamit ng team na wala na. Pumili ng ibang team sa hakbang na iyon, o gumawa sa Team.",
      no_members: "Walang aktibong miyembro ang team na “{{name}}”, kaya walang makakatanggap ng ipapadala ng workflow na ito. Magdagdag ng mga tao sa Team.",
      done: "Handa na ang team na “{{name}}” (aktibong miyembro: {{count}}).",
    },
    member: {
      missing: "May hakbang na nagbabanggit ng taong wala na sa workspace na ito. Pumili ng iba sa hakbang na iyon.",
      not_active: "Hindi aktibong miyembro si {{name}}, kaya wala siyang matatanggap mula sa workflow na ito. Pumili ng iba, o gawing aktibo muli siya sa Team.",
      done: "Aktibong miyembro si {{name}}.",
    },
    lead_stage: {
      missing: "May hakbang na naglilipat ng lead sa yugtong wala na. Pumili ng ibang yugto sa hakbang na iyon.",
      done: "Mayroon ang yugto ng lead na “{{name}}”.",
    },
    handoff_settings: {
      no_default_route: "Ang handoff mula sa {{agents}} na walang tugmang team ay mapupunta sa Owners at Admins, dahil walang default na team o tao. Pumili sa Escalation at handoff sa mga setting ng assistant.",
      done: "May default na team o tao para sa handoff ang bawat assistant.",
    },
    leads_routing: {
      missing: "Iisang tao ang pinapadalhan ng lead routing ng bawat bagong lead, pero wala na siya sa workspace na ito, kaya round-robin na lang ang pamamahagi ng mga bagong lead. Pumili ng ibang default owner sa Leads, Lead routing.",
      not_active: "Si {{name}} ang default owner ng mga bagong lead pero hindi siya aktibong miyembro, kaya round-robin na lang ang pamamahagi ng mga bagong lead. Pumili ng ibang owner sa Leads, Lead routing.",
      cannot_edit_leads: "Si {{name}} ang default owner ng mga bagong lead, pero hindi kayang mag-edit ng lead ng kanyang role para sa bawat assistant na pinagtatrabahuhan ng workflow na ito, kaya round-robin na lang ang pamamahagi ng mga lead na iyon. Bigyan siya ng access sa Team, o pumili ng ibang owner sa Leads, Lead routing.",
      done: "Napupunta kay {{name}}, ang default owner, ang mga bagong lead.",
      done_round_robin: "Round-robin ang pamamahagi ng mga bagong lead sa mga miyembrong kayang mag-edit ng lead.",
    },
    endpoints: {
      done_none: "Wala pang ipapadala: walang webhook endpoint na tumatanggap ng event. Kapag nagdagdag kayo sa Webhooks, ipapadala rito ng workflow na ito ang mga event na sinusubaybayan nito.",
      done_one: "Napupunta ang mga event sa {{count}} webhook endpoint, at ang mga event lang na sinusubaybayan nito ang natatanggap.",
      done_other: "Napupunta ang mga event sa {{count}} webhook endpoint, at ang mga event lang na sinusubaybayan ng bawat isa ang natatanggap nito.",
    },
    office_hours: {
      default_hours: "Sumusunod sa office hours ang workflow na ito, pero wala pang sariling oras ang alinmang assistant. Ang default na linggo ang gagamitin: {{days}} {{from}}–{{to}} ({{timezone}}). Itakda ang oras sa mga setting ng assistant.",
      done: "Nakatakda na ang office hours ({{timezone}}).",
    },
    identity_verification: {
      not_enabled: "Naghahanap ang workflow na ito ng mga na-verify na bisita, pero naka-off ang identity verification sa widget, kaya walang bisitang ituturing na na-verify. I-on ito sa tab na Security ng widget.",
      done: "Naka-on ang identity verification, kaya makikilala ang mga na-verify na bisita.",
    },
    scope: {
      done: "Tumatakbo para sa: {{assistants}}. Mga channel: {{channels}}.",
    },
  },
} as const;
